import { getApiUrl } from '../../../Url';

type RiversideFileUploadAndProcessingParameters = {
  userId: number;
  webEpisodeId: string;
  clipHash: string;
};

type RiversideFileUploadAndProcessingResponse = {
  requestUuid: string;
};

export async function startRiversideFileUploadAndProcessing({
  userId,
  webEpisodeId,
  clipHash,
}: RiversideFileUploadAndProcessingParameters): Promise<RiversideFileUploadAndProcessingResponse> {
  try {
    const resp = await fetch(
      getApiUrl({
        path: `upload/riverside`,
      }),
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          nkrAuthUserId: userId,
          userId,
          webEpisodeId,
          clipHash,
        }),
      }
    );
    if (resp.ok) {
      return resp.json();
    }
    throw new Error(`Could not create process riverside video request`);
  } catch (e) {
    throw new Error(e.message);
  }
}
